<template>
  <div class="contact-list mt-4">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-end mb-2">
      <button
        class="btn btn-sm btn-danger mr-2"
        :disabled="!hasSelected"
        @click="deleteSelected"
      >
        <i class="fas fa-trash-alt"></i> Delete Selected
      </button>
      <button
        class="btn btn-sm btn-outline-primary"
        type="button"
        @click="addRow"
      >
        <i class="fas fa-plus"></i> Add New Row
      </button>
    </div>

    <!-- Native Table -->
    <table class="table table-bordered align-middle">
      <thead class="thead-light">
        <tr>
          <th class="text-center">
            <input type="checkbox" v-model="selectAll" @change="toggleAll" />
          </th>
          <th>Name</th>
          <th>Department</th>
          <th>Job Title</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Mobile Phone</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(contact, index) in contacts" :key="index">
          <td class="text-center">
            <input type="checkbox" v-model="contact.selected" />
          </td>
          <td
            ><input v-model="contact.name" type="text" class="form-control"
          /></td>
          <td
            ><input
              v-model="contact.department"
              type="text"
              class="form-control"
          /></td>
          <td
            ><input v-model="contact.jobTitle" type="text" class="form-control"
          /></td>
          <td
            ><input v-model="contact.email" type="email" class="form-control"
          /></td>
          <td
            ><input v-model="contact.phone" type="text" class="form-control"
          /></td>
          <td
            ><input v-model="contact.mobile" type="text" class="form-control"
          /></td>
          <td class="text-center">
            <button
              class="btn btn-sm btn-link text-danger p-0"
              @click="deleteRow(index)"
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          </td>
        </tr>

        <tr v-if="contacts.length === 0">
          <td colspan="8" class="text-center text-muted py-3"
            >No contacts added.</td
          >
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'FormVendorListContact',
  data() {
    return {
      selectAll: false,
      contacts: [
        {
          selected: false,
          name: 'Andi Pratama',
          department: 'Purchasing',
          jobTitle: 'Purchasing Manager',
          email: 'andi.pratama@sinarlaut.co.id',
          phone: '',
          mobile: '081234567890',
        },
        {
          selected: true,
          name: 'Siti Rahmawati',
          department: 'Operational',
          jobTitle: 'Operational Head',
          email: 'siti@maju-bersama.co.id',
          phone: '',
          mobile: '082345678901',
        },
      ],
    }
  },
  computed: {
    hasSelected() {
      return this.contacts.some((c) => c.selected)
    },
  },
  methods: {
    addRow() {
      this.contacts.push({
        selected: false,
        name: '',
        department: '',
        jobTitle: '',
        email: '',
        phone: '',
        mobile: '',
      })
    },
    deleteRow(index) {
      this.contacts.splice(index, 1)
    },
    deleteSelected() {
      this.contacts = this.contacts.filter((c) => !c.selected)
      this.selectAll = false
    },
    toggleAll() {
      this.contacts.forEach((c) => (c.selected = this.selectAll))
    },
  },
}
</script>

<style scoped>
.table input.form-control {
  height: 32px;
  font-size: 0.875rem;
  padding: 2px 8px;
}
</style>
